<template>
  <div class="page-container">
    <md-app md-mode="fixed">
      <!-- 上部ツールバー -->
      <md-app-toolbar class="md-transparent">
        <div class="md-toolbar-row">
          <div class="md-toolbar-section-start">
            <md-button class="md-icon-button" @click="toggleLeftSidebar"
                       :disabled="measureMode || multiPointMode || movingMyPointMode">
              <md-icon>menu</md-icon>
              <md-tooltip md-direction="bottom">メニュー</md-tooltip>
            </md-button>

            <md-button :disabled="showConfirmDialog || measureMode || multiPointMode || movingMyPointMode"
                       class="md-icon-button" @click="toggleDataLayerSidebar">
              <md-icon v-if="dataLayerSidebar === false || showConfirmDialog === true">layers_clear</md-icon>
              <md-icon v-else>layers</md-icon>
              <md-tooltip md-direction="bottom">レイヤーテーマの表示／非表示</md-tooltip>
            </md-button>

            <to-contract-button :is-button="true"
                                :disabled="searching || measureMode || multiPointMode"
                                v-if="isTrialUser"></to-contract-button>
          </div>
          <md-content class="md-form">
            <div class="md-layout">
              <div class="md-layout-item pr-0">
                <md-field class="search-type">
                  <md-icon>search</md-icon>
                  <md-select v-model="searchType"
                             :disabled="showConfirmDialog || searching || measureMode || multiPointMode">
                    <md-option v-for="searchType in locationSearchTypes" :key="'search-type-' + searchType.code"
                               :value="searchType.code">
                      {{ searchType.name }}
                    </md-option>
                  </md-select>
                </md-field>
                <input id="searchType" type="hidden" :disabled="showConfirmDialog" v-model="searchType" readonly/>
              </div>
              <div class="md-layout-item pr-0">
                <md-field>
                  <md-input id="searchKeyword"
                            :disabled="showConfirmDialog || searching || measureMode || multiPointMode"
                            placeholder="例）東京都…" type="text"
                            autocomplete="off"/>
                </md-field>
              </div>
              <div class="md-layout-item pr-0 md-layout md-alignment-center-left flexbox">
                <md-button id="searchSubmit" :disabled="showConfirmDialog || searching || measureMode || multiPointMode"
                           class="md-primary md-raised md-search-button">
                  <span>検索</span>
                </md-button>
                <md-button
                    :disabled="showConfirmDialog || searching || measureMode || multiPointMode || movingMyPointMode"
                    @click.natice="clickTemporaryHideImages()" class="md-icon-button md-raised"
                >
                  <md-icon>{{ temporaryHideImages ? 'visibility_off' : 'map' }}</md-icon>
                  <md-tooltip md-direction="bottom">図面の表示／非表示</md-tooltip>
                </md-button>
                <md-button
                    :disabled="showConfirmDialog || searching || measureMode || multiPointMode || movingMyPointMode"
                    @click.natice="toggleMyMarkers()" class="md-icon-button md-raised"
                >
                  <md-icon>{{ myMarkers ? 'location_on' : 'location_off' }}</md-icon>
                  <md-tooltip md-direction="bottom">マイマーカーの表示／非表示</md-tooltip>
                </md-button>
                <md-button :disabled="showConfirmDialog || searching || measureMode || multiPointMode"
                           @click.natice="geolocation()"
                           class="md-icon-button md-raised">
                  <md-icon>gps_fixed</md-icon>
                  <md-tooltip md-direction="bottom">現在地を表示</md-tooltip>
                </md-button>
              </div>
            </div>
          </md-content>
          <div class="md-toolbar-section-end">
            <md-button @click="clickOpenGuide()">
              <md-icon>picture_as_pdf</md-icon>
              <md-tooltip md-direction="bottom">操作ガイド</md-tooltip>
              <span>操作ガイド</span>
            </md-button>
            <md-button :disabled="showConfirmDialog || measureMode || multiPointMode || movingMyPointMode"
                       @click="toggleRightSidebar"
                       class="md-icon-button">
              <md-icon v-if="rightSidebar === false || showConfirmDialog === true">playlist_play</md-icon>
              <md-icon v-else>close</md-icon>
              <md-tooltip md-direction="bottom">マイマーカーリスト</md-tooltip>
            </md-button>
          </div>
        </div>
      </md-app-toolbar>

      <!-- 左サイドバー -->
      <md-app-drawer v-if="menuVisible && !measureMode && !multiPointMode" :md-right="false"
                     :md-active.sync="menuVisible">
        <user-sidebar ref="sidebar"></user-sidebar>
      </md-app-drawer>

      <md-app-content class="md-layout" id="app-content">
        <!-- データレイヤーサイドバー -->
        <map-data-layer-sidebar v-if="dataLayerSidebar && !showConfirmDialog && !measureMode && !multiPointMode"
                                class="md-layout-item md-left-sidebar"
                                v-on:layer-type="isKokudoYouto">
        </map-data-layer-sidebar>

        <!-- Google Map -->
        <map-google
            ref="map_google"
            v-bind:accountId="accountId"
            v-bind:centerPoint="centerPoint"
            v-bind:currentLocation="currentLocation"
            v-bind:chibanLists="chibanLists"
            v-bind:class="{'md-layout-item':rightSidebar || dataLayerSidebar,'md-layout-item md-size-100':!rightSidebar && !dataLayerSidebar,'google-map':true}"
            v-bind:myMarkers="myMarkers"
            v-bind:pdfActive="pdfActive"
            v-bind:showConfirmDialog="showConfirmDialog"
            v-bind:temporaryHideImages="temporaryHideImages"
            v-bind:measureMode="measureMode"
            v-bind:showAddress="showAddress"
            v-bind:movingMyPointMode="movingMyPointMode"
            v-bind:destinationPointMode="destinationPointMode"
            v-bind:multiPointMode="multiPointMode"
            v-bind:showMultiPointConfirmDialog="showMultiPointConfirmDialog"
            @beginSearch="beginSearch"
            @geocodingNotFound="geocodingNotFound"
            @getMapInit="getMapInit"
            @getPdfRegistrations="getPdfRegistrations"
            @updateMapZoom="updateMapZoom"
            @jonSearchNotFound="jonSearchNotFound"
            @landMarkerRightClick="landMarkerRightClick"
            @landMapClicked="landMapClicked"
            @loadPdfRegistrations="loadPdfRegistrations"
            @mapMarkerRightClick="mapMarkerRightClick"
            @refreshChibanLists="refreshChibanLists"
            @requiredAddress="requiredAddress"
            @beforeRightClick="closeCtxMenu"
            @rightClick="rightClick"
            @rightClickGeoLayer="rightClickGeoLayer"
            @searched="searched"
            @setLoadPoint="setLoadPoint"
            @showRightSidebar="showRightSidebar"
            @displayMeasureResult="displayMeasureResult"
            @getMapMultiPointInit="getMapMultiPointInit"
            @setLoadMultiPoint="setLoadMultiPoint"
            @updateMovingPoints="updateMovingPoints"
            @addressShowed="addressShowed"
        ></map-google>

        <!-- メッセージ：成功 -->
        <md-snackbar :md-active="true" :md-duration="snackbarDuration" v-show="showSnackBar"
                     class="md-snackbar-bg__success" :key="'snackbar-success'"
                     @md-closed="showSnackBar = false">
          <span>{{ successMessage }}</span>
          <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
        </md-snackbar>

        <!-- メッセージ：失敗 -->
        <md-snackbar :md-active="true" :md-position="'center'" class="md-snackbar-bg__error"
                     v-if="errorMessages.length">
          <flash-message :errors="errorMessages" :inSnackbar="true"></flash-message>
          <md-button class="md-primary" @click="errorMessages = []">閉じる</md-button>
        </md-snackbar>

        <!-- Show pdf error message -->
        <md-snackbar class="md-snackbar-bg__white" :md-position="'center'" :md-active="true"
                     :md-duration="snackbarDuration" v-if="pdfErrorMessage !== null">
          <flash-message :errors="[pdfErrorMessage]" :inSnackbar="true"></flash-message>
          <md-button class="md-primary btn-error-close" @click="pdfErrorMessage = null">閉じる</md-button>
        </md-snackbar>

        <!-- Show measure modal -->
        <md-snackbar class="md-snackbar-bg__information" :md-position="'center'" :md-active="true"
                     :md-duration="snackbarDuration" v-if="measureMode">
          <div>
            <span><b>距離・面積測定モード</b></span><br/>
            <span class="caption">地図をクリックして測定する経路を描きます</span><br/>
            <span v-if="measureResult" class="measure-result">{{ measureResult }}</span>
            <span v-else class="md-caption">※距離は3点以上のときは外周を算出します。</span>
          </div>
          <md-button class="md-raised" @click="clearMeasureMarkers">クリア</md-button>
          <md-button class="md-raised" @click="exitMeasureMode">閉じる</md-button>
        </md-snackbar>

        <!-- Show multiple points modal -->
        <md-snackbar class="md-snackbar-bg__information" :md-position="'center'" :md-active="true"
                     :md-duration="snackbarDuration"
                     v-if="multiPointMode"
                     v-show="!showMultiPointConfirmDialog && !showRegistrationDialog">
          <div>
            <span><b>複数地点を選択</b></span><br/>
            <span class="caption">複数の登記情報を同時に取得できます</span><br/>
            <span class="caption">土地のみ{{ common.limitMultiPoint }}件まで</span>
          </div>
          <md-button class="md-primary md-raised" @click="onMenuRegistryClick">登記情報</md-button>
          <md-button class="md-raised" @click="clearMultiPointMarkers">クリア</md-button>
          <md-button class="md-raised" @click="exitMultiPointMode">閉じる</md-button>
        </md-snackbar>

        <!-- Show moving my points modal -->
        <md-snackbar class="md-snackbar-bg__information md-snackbar-wide" :md-position="'center'" :md-active="true"
                     :md-duration="snackbarDuration"
                     v-if="movingMyPointMode"
                     v-show="!showMultiPointConfirmDialog && !showRegistrationDialog">
          <div>
            <span><b>マイマーカー位置変更モード</b></span>
            <p class="caption" v-if="destinationPointMode">移動先の位置を地図上で選択してください。</p>
            <p class="caption" v-else>
              移動させるマイマーカーを地図上で選択し、マイマーカーリストから登記情報を選択してください。</p>
            <p class="x-caption" v-if="destinationPointMode">※クリックすると赤いピンが立ちます。</p>
            <p class="x-caption" v-else>
              ※移動できるのは自アカウントのマイマーカーです。他アカウントのマイマーカーは非表示になっています。</p>
            <p v-if="selectedMovingPointsCount && !destinationPointMode" class="moving-points">
              選択：{{ selectedMovingPointsCount }}件</p>
          </div>
          <div class="md-snackbar-button">
            <md-button class="md-primary md-raised" @click="onSelectedMovingPointClick" v-if="!destinationPointMode"
                       :disabled="selectedMovingPointsCount === 0 || showConfirmMovingMyPoints">次へ
            </md-button>
            <md-button class="md-primary md-raised" @click="onApplyMovingClick" v-if="destinationPointMode"
                       :disabled="selectedMovingPointsCount === 0 || showConfirmMovingMyPoints">次へ
            </md-button>
            <md-button class="md-raised" @click="onCancelMovingClick"
                       :disabled="movingPoints.length === 0 || showConfirmMovingMyPoints">クリア
            </md-button>
            <md-button class="md-raised" @click="exitMovingMyPageMode" :disabled="showConfirmMovingMyPoints">閉じる
            </md-button>
          </div>
        </md-snackbar>
        <Cite
            v-if="dataLayerSidebar && !showConfirmDialog && !measureMode && !multiPointMode && isLayerTypeKoudoYouto"
            :is-my-marker-list-open="rightSidebar && !showConfirmDialog"
        ></Cite>

        <!-- マイマーカーの移動を確認 -->
        <confirm-modal
            :md-active.sync="showConfirmMovingMyPoints"
            :md-click-outside-to-close="false"
            :md-close-on-esc="false"
            :sending="sending"
            :md-confirm-text="'OK'"
            :md-cancel-text="'キャンセル'"
            :background="'#CCCCCC'"
            md-content="マイマーカーを移動します。よろしいですか？"
            md-title="マイマーカーの移動を確認"
            @md-cancel="onCancelMovingMyPoints"
            @md-confirm="onConfirmMovingMyPoints"/>

        <!-- 右サイドバー -->
        <div class="md-layout-item md-right-sidebar" v-if="rightSidebar && !showConfirmDialog">
          <md-toolbar class="md-layout md-transparent md-right-sidebar__header" md-elevation="0">
            <md-field class="md-layout-item">
              <md-icon>search</md-icon>
              <md-input type="text" v-model="keyword" name="keyword" autocomplete="off"/>
            </md-field>
            <!-- 絞り込み条件 -->
            <md-table class="md-registrations" :class="{'md-registrations_3column': movingMyPointMode}" md-sort="date"
                      md-sort-order="asc">
              <md-table-row>
                <md-table-head v-if="movingMyPointMode">
                  <md-button class="md-icon-button md-primary" :disabled="destinationPointMode"
                             @click="toggleSelectedMovingPoints">
                    <md-icon>done_all</md-icon>
                  </md-button>
                </md-table-head>
                <md-table-head md-sort-by="date">
                  <a href="#" @click="sortBy('based_at')"
                     v-bind:class="{'active' : sortKey === 'based_at'}">取得日
                  </a>
                  <md-icon v-if="sortDirection === 'desc' && sortKey === 'based_at'">arrow_downward</md-icon>
                  <md-icon v-if="sortDirection === 'asc' && sortKey === 'based_at'">arrow_upward</md-icon>
                </md-table-head>
                <md-table-head md-sort-by="address">
                  <a href="#" @click="sortBy('label')"
                     v-bind:class="{'active' : sortKey === 'label'}">所在
                  </a>
                  <md-icon v-if="sortDirection === 'desc' && sortKey === 'label'">arrow_downward
                  </md-icon>
                  <md-icon v-if="sortDirection === 'asc' && sortKey === 'label'">arrow_upward</md-icon>
                </md-table-head>
              </md-table-row>
            </md-table>
          </md-toolbar>
          <!-- ロード中表示 -->
          <md-content v-if="loadRegistrations && !movingMyPointMode" class="md-right-sidebar__content">
            <div class="md-layout md-right-sidebar__content-message md-alignment-center-center">
              <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
            </div>
          </md-content>
          <!-- メッセージ「地図を拡大してください」 -->
          <md-content v-else-if="outOfMyMarkerRange()" class="md-right-sidebar__content">
            <div class="md-layout md-right-sidebar__content-message md-alignment-center-center">
              <div class="md-layout-item md-size-90">
                <span class="md-title">地図を拡大してください</span>
              </div>
            </div>
          </md-content>
          <md-content class="md-registrations md-scrollbar md-right-sidebar__content" v-else>
            <md-table md-sort="date" md-sort-order="asc">
              <!-- マイマーカーの一覧 -->
              <md-table-row v-for="(item, index) in registrationItems" v-bind:key="'registration-item-key-' + index">
                <md-table-cell colspan="2" v-if="item.label.indexOf(keyword) >= 0"
                               @click.native="pdfClick(item.id)"
                               @mouseover.native="pdfMouseover(item.id)" @mouseout.native="pdfMouseout()">
                  <md-button :class="acquiredBySelf(item.account_id)"
                             @click.prevent="downloadPdf(item)"
                             class="md-icon-button md-raised md-primary">
                    <md-icon>picture_as_pdf</md-icon>
                    <md-tooltip md-direction="bottom">PDFを開く</md-tooltip>
                  </md-button>
                  <md-button class="md-icon-button md-raised md-primary"
                             @click.stop="reObtainRegistrationInformation(item)">
                    <md-icon>open_in_browser</md-icon>
                    <md-tooltip md-direction="bottom">登記情報取得画面へ</md-tooltip>
                  </md-button>
                  <span class="md-caption">
                    {{ datetimeFormat(item.based_at, 'YYYY-MM-DD HH:mm') }} {{ getPdfTypeName(item.pdf_type) }}
                  </span>
                  <span class="md-address">{{ item.label }}</span>
                </md-table-cell>
              </md-table-row>
              <!-- 「マイマーカーの位置を変更する」モード用一覧 -->
              <md-table-row v-for="(item, index) in movingPoints" v-bind:key="'moving-point-item-key-' + index">
                <md-table-cell colspan="2" v-if="item.label.indexOf(keyword) >= 0"
                               @click.native="pdfClick(item.id)"
                               @mouseover.native="pdfMouseover(item.id)" @mouseout.native="pdfMouseout()">
                  <md-checkbox v-model="item.checked" class="moving-point-checkbox" :disabled="destinationPointMode"
                               @change="changeMovingPoints(index)"></md-checkbox>
                  <md-button :class="acquiredBySelf(item.account_id)"
                             @click.prevent="downloadPdf(item)"
                             class="md-icon-button md-raised md-primary">
                    <md-icon>picture_as_pdf</md-icon>
                    <md-tooltip md-direction="bottom">PDFを開く</md-tooltip>
                  </md-button>
                  <span class="md-caption">
                    {{ datetimeFormat(item.based_at, 'YYYY-MM-DD HH:mm') }} {{ getPdfTypeName(item.pdf_type) }}
                  </span>
                  <span class="md-address">{{ item.label }}</span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-content>
          <div class="md-right-sidebar__footer">
            <md-button class="md-button md-primary md-raised md-size-100"
                       :disabled="loadRegistrations || movingMyPointMode"
                       @click="onMovingPointClick">マイマーカーの位置を変更する
            </md-button>
          </div>
        </div>

        <!-- 地図右クリック時のメニュー -->
        <context-menu id="context-menu" ref="menu">
          <li>
            <a href="#" @click.prevent="onMenuItemClick($event.target.innerText)">JON地番地図</a>
          </li>
          <li>
            <a href="#" @click.prevent="onMenuItemClick($event.target.innerText)">路線価図</a>
          </li>
          <li>
            <a href="#" @click.prevent="onAddressItemClick()">住所</a>
          </li>
          <li>
            <a href="#" @click.prevent="onMeasureItemClick()">距離・面積測定モード</a>
          </li>
        </context-menu>

        <!-- Context menu registry -->
        <context-menu id="context-menu-registry" ref="menu_registry">
          <li>
            <a href="#" @click.prevent="onMenuRegistryClick()">登記情報</a>
          </li>
          <li>
            <a href="#" @click.prevent="onMenuItemClick($event.target.innerText)">路線価図</a>
          </li>
          <li>
            <a href="#" @click.prevent="onAddressItemClick()">住所</a>
          </li>
          <li>
            <a href="#" @click.prevent="onMeasureItemClick()">距離・面積測定モード</a>
          </li>
          <li>
            <a href="#" @click.prevent="onMultiPointClick()">複数地点選択モード</a>
          </li>
        </context-menu>

        <!-- 路線価図モーダル -->
        <ui-dialog class="rosen-modal" v-bind:hidden="temporaryHideImages"
                   v-bind:src="img.src" v-bind:key="'rosen-image-key-' + index"
                   v-for="(img, index) in imagesLists" @closed="rosenClosed" v-if="imagesLists.length"></ui-dialog>

        <!-- 地番確認ウィンドウ -->
        <parcel-confirm-dialog v-if="showConfirmDialog"
                               :show-confirm-dialog="showConfirmDialog"
                               :load-point="loadPoint"
                               :map-init="mapInit"
                               @parcelConfirmed="parcelConfirmed"
                               @closed="parcelConfirmClosed"
        ></parcel-confirm-dialog>

        <!-- メッセージウィンドウ -->
        <message-dialog v-if="outOfMyMarkerRange()"
                        :message="'地図を拡大するとマイマーカーが表示されます。'"></message-dialog>

        <!-- 地番確認ウィンドウ(複数地点版) -->
        <multi-point-confirm-dialog v-if="showMultiPointConfirmDialog"
                                    :show-multi-point-confirm-dialog="showMultiPointConfirmDialog"
                                    :load-multi-point="loadMultiPoint"
                                    :map-init="mapInit"
                                    @multiPointConfirmed="multiPointConfirmed"
                                    @closed="multiPointConfirmClosed"
        ></multi-point-confirm-dialog>

        <!-- 登記情報取得モーダル -->
        <map-registration-dialog
            :md-active.sync="showRegistrationDialog"
            :parcel-number="parcelNumber"
            :multi-parcel-number="multiParcelNumber"
            :registration-item="registrationItem"
            :map-init="mapInit"
            :t-service-id="tServiceId"
            :is-trial-user="isTrialUser"
            :load-re-obtain-registration-info="loadReObtainRegistrationInfo"
            @displayErrors="displayRegistryErrors"
            @displayPdfError="displayPdfError"
            @close="registrationDialogClosed"
            @exitMultiPointMode="exitMultiPointMode"
        ></map-registration-dialog>

        <!-- お知らせモーダル -->
        <information-dialog
            :md-active.sync="showInformationDialog"
        ></information-dialog>

        <loading-spinner-overlay :background="'#000000'"
                                 v-show="showLoadingSpinner()"
        ></loading-spinner-overlay>

        <!-- 無料トライアル終了後のアナウンス-->
        <announce-trial-ended :show-dialog="isTrialEnded" v-if="isTrialUser"></announce-trial-ended>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import MdTablePagination                              from '../../../components/Pagination';
import MapGoogle                                      from '../../../components/frontend/map/MapGoogle';
import MapDataLayerSidebar                            from '../../../components/frontend/map/MapDataLayerSidebar';
import MapRegistrationDialog                          from '../../../components/frontend/map/MapRegistrationDialog';
import UiDialog                                       from '../../../components/frontend/map/UiDialog';
import MessageDialog                                  from '../../../components/frontend/map/MessageDialog';
import ParcelConfirmDialog                            from "../../../components/frontend/map/ParcelConfirmDialog";
import MultiPointConfirmDialog                        from "../../../components/frontend/map/MultiPointConfirmDialog";
import UserSidebar                                    from '../../../components/backend/user/UserSidebar';
import FlashMessage                                   from '../../../components/FlashMessage';
import ToContractButton                               from "../../../components/trial/ToContractButton";
import AnnounceTrialEnded                             from "../../../components/trial/AnnounceTrialEnded";
import ContextMenu                                    from 'vue-context-menu';
import {apiClientWithUserToken as apiClient, apiList} from "../../../modules/apiClient";
import CommonMixin                                    from "../../../mixins/commonMixin";
import Common                                         from "../../../modules/common";
import moment                                         from 'moment-timezone';
import {validationMixin}                              from 'vuelidate'
import LoadingSpinnerOverlay                          from "../../../components/LoadingSpinnerOverlay";
import InformationDialog                              from "../../../components/frontend/map/InformationDialog";
import ConfirmModal                                   from "../../../components/ConfirmModal";
import GPS                                            from "../../../modules/gps";
import Map                                            from '../../../modules/map';
import MultiPoint                                     from '../../../modules/map/multiPoint';
import DataLayer                                      from '../../../modules/map/dataLayer';
import MovingMyPoint                                  from '../../../modules/map/movingMyPoint';
import Cite                                           from "../../../components/Cite.vue";

moment.locale('ja');
export default {
  name      : 'Map',
  props     : {
    latitude : {
      type   : [String, Number],
      default: null,
    },
    longitude: {
      type   : [String, Number],
      default: null,
    },
  },
  components: {
    ConfirmModal,
    ParcelConfirmDialog,
    LoadingSpinnerOverlay,
    MdTablePagination,
    FlashMessage,
    MapGoogle,
    ContextMenu,
    UiDialog,
    MessageDialog,
    UserSidebar,
    MapDataLayerSidebar,
    MapRegistrationDialog,
    MultiPointConfirmDialog,
    InformationDialog,
    ToContractButton,
    AnnounceTrialEnded,
    Cite,
  },
  mixins    : [validationMixin, CommonMixin],
  data() {
    return {
      menuVisible                 : false,
      myMarkers                   : true,
      rightSidebar                : false,
      dataLayerSidebar            : false,
      locationSearchTypes         : Common.locationSearchTypes,
      searchType                  : Common.locationSearchTypes.google.code,
      searching                   : false,
      keyword                     : '',
      loadRegistrations           : false,
      showConfirmDialog           : false,
      showMessageDialog           : false,
      showRegistrationDialog      : false,
      showInformationDialog       : false,
      parcelNumber                : null,
      registrationItem            : null,
      rosenSrc                    : '/img/rosen.jpg',
      imagesLists                 : [],
      chibanLists                 : [],
      items                       : [],
      date                        : "2019-01-10",
      sortDirection               : 'desc',
      sortKey                     : 'date',
      marker                      : {
        latitude : null,
        longitude: null
      },
      zoom                        : 0,
      url                         : '',
      mapInit                     : null,
      initLoading                 : true,
      isTrialUser                 : false,
      isTrialEnded                : false,
      loadPoint                   : false,
      loadMultiPoint              : false,
      loadChibanRosen             : false,
      tServiceId                  : null,
      currentDate                 : moment().format(Common.momentConst.dateFormat),
      accountId                   : null,
      pdfActive                   : null,
      temporaryHideImages         : false,
      centerPoint                 : null,
      currentLocation             : null,
      pdfTypes                    : Common.pdfTypes,
      pdfErrorMessage             : null,
      common                      : Common,
      measureMode                 : false,
      measureResult               : null,
      showAddress                 : false,
      multiPointMode              : false,
      multiParcelNumber           : [],
      showMultiPointConfirmDialog : false,
      loadReObtainRegistrationInfo: false,
      landMarkerPoint             : null,
      movingMyPointMode           : false,
      movingPoints                : [],
      destinationPointMode        : false,
      showConfirmMovingMyPoints   : false,
      isLayerTypeKoudoYouto       : false,
    }
  },
  beforeMount() {
    if (this.$props.latitude && this.$props.longitude) {
      Map.setInitPoint({
        lat: this.$props.latitude,
        lng: this.$props.longitude
      });
      this.showRightSidebar();
    }
  },
  mounted() {
    this.getSnackBar();
    this.initDisplay();
    this.initAccount();
    this.initChibanImagings();
  },
  destroyed() {
    this.exitMeasureMode();
    this.exitMovingMyPageMode();
  },
  watch   : {
    errorMessages: function (messages) {
      /**
       * メッセージを指定秒数後に閉じる
       */
      if (messages.length === 0) {
        return;
      }

      const self = this;
      setTimeout(function () {
        self.errorMessages = [];
      }, Common.snackbarAutoCloseTime);
    },
  },
  computed: {
    registrationItems: function () {
      if (!this.items.data) {
        return [];
      }
      if (this.movingMyPointMode) {
        return [];
      }
      return this.items.data;
    },
    selectedMovingPointsCount() {
      return this.movingPoints.filter(p => p.checked).length;
    },
  },
  methods : {
    initDisplay() {
      apiClient.get(apiList.accounts.status)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }

            this.isTrialEnded = response.data.status === Common.trialEndedStatus;
            this.isTrialUser  = this.isTrialEnded || response.data.status === Common.trialStatus;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.initLoading = false;
          });
    },

    initAccount() {
      apiClient.get(apiList.jon.accounts.auth)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.tServiceId = response.data.t_service_id;
            this.accountId  = response.data.id;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
          });
    },

    initChibanImagings() {
      const self = this;
      apiClient.get(apiList.history.chibans)
          .then(response => {
            if (self.hasResponseErrors(response)) {
              return;
            }
            const chibans = response.data;
            if (chibans.length > 0) {
              chibans.forEach(function (chiban) {
                const mapGround = {
                  processedAt: chiban.processed_at,
                  imageBounds: {
                    north: chiban.northeast_latitude,
                    south: chiban.southwest_latitude,
                    east : chiban.northeast_longitude,
                    west : chiban.southwest_longitude
                  },
                  imageSrc   : chiban.pre_signed_url
                };
                self.chibanLists.push(mapGround);
              });
              self.sortChibanLists();
              self.temporaryHideImages = false;
            }
          })
          .catch(error => {
            self.errorMessages = [error.message];
          })
          .finally(() => {
          });
    },

    /**
     * 各種メニューを閉じる(メニューが開いていた場合)
     */
    closeCtxMenu() {
      if (this.$refs.menu.ctxVisible === true) {
        this.$refs.menu.ctxVisible = false;
        this.$refs.menu.$emit('ctx-close', this.locals);
        this.$refs.menu.bodyClickListener.stop();
      }
      if (this.$refs.menu_registry.ctxVisible === true) {
        this.$refs.menu_registry.ctxVisible = false;
        this.$refs.menu_registry.$emit('ctx-close', this.locals);
        this.$refs.menu_registry.bodyClickListener.stop();
      }
    },

    /**
     * 地図上を右クリックした際のイベント
     */
    rightClick({e, message}) {
      if (message) {
        this.errorMessages = [message];
        return;
      }
      this.errorMessages = [];

      this.loadPoint                      = true;
      // Open context menu
      this.marker                         = {
        latitude : e.latLng.lat(),
        longitude: e.latLng.lng()
      };
      this.$refs.menu_registry.ctxVisible = false;
      this.$refs.menu.open(Common.getMouseEvent(e));
    },
    /**
     * Right click on land marker
     */
    landMarkerRightClick({e, point}) {
      this.landMarkerPoint = point;
      if (!(point && point.lat && point.lng)) {
        return;
      }
      // マイマーカー（取得済みの登記情報）の場合、右クリックメニューを表示しない。（V1コードが存在するため、それをキーに判断する）
      if (point.v1Code) {
        return;
      }

      // Open context menu
      this.marker                = {
        latitude : point.lat,
        longitude: point.lng,
      };
      this.$refs.menu.ctxVisible = false;
      if (this.multiPointMode) {
        return;
      }
      this.$refs.menu_registry.open(Common.getMouseEvent(e));
    },
    /**
     * Right click on map marker
     */
    mapMarkerRightClick({e, point}) {
      if (!(point && point.lat && point.lng)) {
        return;
      }
      // Open context menu
      this.marker                         = {
        latitude : point.lat,
        longitude: point.lng,
      };
      this.$refs.menu_registry.ctxVisible = false;
      this.$refs.menu.open(Common.getMouseEvent(e));
    },
    /**
     * Right click on geo json data layer
     */
    rightClickGeoLayer() {
      this.errorMessages = [Common.messages.map.rightClickGeoLayer];
    },
    getMapInit(mapInit) {
      this.loadPoint                    = false;
      this.loadReObtainRegistrationInfo = false;
      this.mapInit                      = mapInit;
    },

    getMapMultiPointInit(mapInit) {
      this.loadMultiPoint = false;
      this.mapInit        = mapInit;
    },

    getPdfRegistrations(pdfRegistrations) {
      if (pdfRegistrations.errors) {
        return;
      }
      this.zoom  = Map.getZoom();
      this.items = pdfRegistrations;
      this.sortBy(this.sortKey);
    },

    outOfMyMarkerRange() {
      return this.zoom ? this.zoom < Map.MARKER.REGISTRIES_REQUEST_MIN_ZOOM : false;
    },

    showRightSidebar() {
      this.rightSidebar = true;
      this.myMarkers    = true;
    },

    refreshChibanLists(newList) {
      this.chibanLists         = newList;
      this.temporaryHideImages = false;
    },

    onMenuItemClick(text) {
      if (text === 'JON地番地図') {
        this.getChibanImaging();
      } else {
        this.getMapRosenImage();
      }
    },

    onMeasureItemClick() {
      this.measureMode      = true;
      this.dataLayerSidebar = false;
      this.rightSidebar     = false;
    },
    onAddressItemClick() {
      this.showAddress = true;
    },
    addressShowed() {
      this.showAddress = false;
    },

    onMultiPointClick() {
      this.multiPointMode   = !this.multiPointMode;
      this.dataLayerSidebar = false;
      this.rightSidebar     = false;
    },

    clearMeasureMarkers() {
      this.measureResult = null;
      Map.clearMeasureMarkers();
    },
    exitMeasureMode() {
      this.clearMeasureMarkers();
      this.measureMode = false;
    },
    displayMeasureResult(measureResult) {
      this.measureResult = measureResult;
    },
    clearMultiPointMarkers() {
      MultiPoint.clearMarkers();
    },
    exitMultiPointMode() {
      this.multiPointMode = false;
    },
    updateMovingPoints(points) {
      this.movingPoints.splice(0, this.movingPoints.length);
      this.movingPoints.push(...points);
    },
    toggleSelectedMovingPoints() {
      const selected = this.movingPoints.filter(p => p.checked).length;
      const checked  = this.movingPoints.length !== selected;
      return this.movingPoints.map(p => p.checked = checked);
    },
    changeMovingPoints(index) {
      if (this.movingPoints[index]) {
        MovingMyPoint.selectedChange(this.movingPoints[index].id, this.movingPoints[index].checked);
      }
    },
    onMovingPointClick() {
      this.movingMyPointMode    = true;
      this.destinationPointMode = false;
      this.rightSidebar         = true;
      this.dataLayerSidebar     = false;
    },
    onSelectedMovingPointClick() {
      if (this.selectedMovingPointsCount === 0) {
        this.errorMessages = [Common.messages.map.requiredMovingPoint];
        return;
      }
      this.destinationPointMode = true;
    },
    onApplyMovingClick() {
      if (MovingMyPoint.getDestination() === null) {
        this.errorMessages = [Common.messages.map.requiredDestination];
        return;
      }
      this.showConfirmMovingMyPoints = true;
    },
    onCancelMovingClick() {
      this.movingPoints         = [];
      this.destinationPointMode = false;
      MovingMyPoint.setPoints([]);
      MovingMyPoint.clearMarker();
    },
    exitMovingMyPageMode() {
      this.movingPoints         = [];
      this.movingMyPointMode    = false;
      this.destinationPointMode = false;
    },
    onConfirmMovingMyPoints() {
      this.applyMovingMyPoints();
    },
    onCancelMovingMyPoints() {
      this.showConfirmMovingMyPoints = false;
    },
    /**
     * Apply moving my points
     */
    applyMovingMyPoints() {
      const self            = this;
      self.sending          = true;
      self.validateResponse = [];
      const params          = {
        registry_ids: self.movingPoints.filter((p) => p.checked).map((p) => p.id),
        latitude    : MovingMyPoint.getDestination().lat(),
        longitude   : MovingMyPoint.getDestination().lng(),
      };
      apiClient.put(apiList.user.updateRegistries, params)
          .then(response => {
            if (self.hasResponseErrors(response)) {
              self.errorMessages = [Common.messages.movingMyPoint.failure];
              return;
            }
            self.successMessage = Common.messages.movingMyPoint.success;
            self.showSnackBar   = true;
            setTimeout(function () {
              self.showSnackBar   = false;
              self.successMessage = null;
            }, Common.snackbarAutoCloseTime);
            self.exitMovingMyPageMode();
          })
          .catch(error => {
            self.errorMessages = [Common.messages.movingMyPoint.failure];
          })
          .finally(() => {
            self.sending                   = false;
            self.showConfirmMovingMyPoints = false;
          });
    },

    landMapClicked(e) {
      this.marker                = {
        latitude : e.latLng.lat(),
        longitude: e.latLng.lng()
      };
      // Open context menu pdf registry
      this.$refs.menu.ctxVisible = false;
      if (this.multiPointMode) {
        return;
      }
      this.$refs.menu_registry.open(Common.getMouseEvent(e));
    },

    onMenuRegistryClick() {
      if (this.multiPointMode && MultiPoint.getPoints().length === 0) {
        this.errorMessages = [Common.messages.map.requiredMultiPoint];
        return;
      }

      const self            = this;
      this.rightSidebar     = false;
      this.dataLayerSidebar = false;
      this.$nextTick(function () {
        if (self.landMarkerPoint && self.landMarkerPoint.number_type !== undefined) {
          self.reObtainRegistrationInformation(self.landMarkerPoint);
          return;
        }
        self.showConfirmDialog      = true;
        self.showRegistrationDialog = false;
        if (self.multiPointMode) {
          self.loadMultiPoint              = true;
          self.showConfirmDialog           = false;
          self.showMultiPointConfirmDialog = true;
        }
      });
    },

    setLoadPoint(loadPoint) {
      this.loadPoint = loadPoint;
      if (this.loadPoint) {
        this.mapInit = null;
      } else if (this.mapInit === null && this.showConfirmDialog) {
        this.errorMessages = [Common.messages.map.lotNumberNotFound];
      }
    },

    setLoadMultiPoint(loadMultiPoint) {
      this.loadMultiPoint = loadMultiPoint;
    },

    rosenClosed() {
      this.imagesLists = [];
    },

    parcelConfirmClosed() {
      this.rightSidebar           = false;
      this.dataLayerSidebar       = false;
      this.showConfirmDialog      = false;
      this.showRegistrationDialog = false;
      this.parcelNumber           = null;
    },

    multiPointConfirmClosed() {
      this.rightSidebar                = false;
      this.dataLayerSidebar            = false;
      this.showMultiPointConfirmDialog = false;
      this.showRegistrationDialog      = false;
    },

    parcelConfirmed(parcelNumber) {
      this.showConfirmDialog      = false;
      this.showRegistrationDialog = true;
      this.parcelNumber           = parcelNumber;
    },

    multiPointConfirmed(multiParcelNumber) {
      this.showRegistrationDialog = true;
      this.multiParcelNumber      = multiParcelNumber;
    },

    buildingConfirmed(registrationItem) {
      this.showRegistrationDialog = true;
      this.registrationItem       = registrationItem;
    },

    getChibanImaging() {
      const self           = this;
      self.loadChibanRosen = true;
      const params         = {
        latitude : self.marker.latitude,
        longitude: self.marker.longitude,
        tab_id   : sessionStorage.tabID,
      };
      apiClient.get(apiList.jon.chiban, {params: params})
          .then(response => {
            if (self.hasResponseErrors(response)) {
              return;
            }

            // すでに最大件数を取得済みであれば、古い画像を削除する
            if (self.chibanLists.length >= response.data.max_chiban_count) {
              self.sortChibanLists();
              while (self.chibanLists.length >= response.data.max_chiban_count) {
                self.chibanLists.shift();
              }
            }

            self.chibanLists.push({
              processedAt: response.data.processed_at,
              imageBounds: {
                north: response.data.northeast.latitude,
                south: response.data.southwest.latitude,
                east : response.data.northeast.longitude,
                west : response.data.southwest.longitude
              },
              imageSrc   : response.data.pre_signed_url
            });
            self.temporaryHideImages = false;
          })
          .catch(() => {
            self.errorMessages = [Common.messages.map.rightClickGeoLayer];
          })
          .finally(() => {
            self.loadChibanRosen = false;
          });
    },
    /**
     * JON地番地図を昇順で並び替え
     */
    sortChibanLists() {
      this.chibanLists = this.chibanLists.sort((a, b) => {
        if (a.processedAt < b.processedAt) return -1;
        if (a.processedAt > b.processedAt) return 1;
        return 0;
      });
    },
    getMapRosenImage() {
      this.loadChibanRosen = true;
      const params         = {
        latitude : this.marker.latitude,
        longitude: this.marker.longitude,
        tab_id   : sessionStorage.tabID,
      };
      apiClient
          .get(apiList.jon.rosen, {params: params})
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            if (response.data.pre_signed_url) {
              if (this.imagesLists.length === Common.mapRosenImagingLimit) {
                this.imagesLists.shift();
              }
              this.imagesLists.push({
                src: response.data.pre_signed_url
              });
            } else {
              this.errorMessages = [Common.messages.map.routeMapNotFound];
            }
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.loadChibanRosen = false;
          });
    },

    toggleLeftSidebar() {
      this.menuVisible = !this.menuVisible;
    },

    toggleRightSidebar() {
      this.rightSidebar = !this.rightSidebar;
      if (this.rightSidebar) {
        this.myMarkers = true;
      }
    },

    toggleDataLayerSidebar() {
      this.isLayerTypeKoudoYouto = false;
      this.dataLayerSidebar      = !this.dataLayerSidebar;
      Map.updateNALayerVisible(true);
      DataLayer.setDataLayerSidebar(this.dataLayerSidebar);
    },

    sortBy: function (sortKey) {
      if (this.items.length === 0) {
        return;
      }
      this.sortKey = sortKey;
      if (this.sortDirection === 'asc') {
        this.items.data.sort((a, b) => (a[sortKey] > b[sortKey]) ? 1 : (a[sortKey] === b[sortKey]) ? ((a[sortKey] > b[sortKey]) ? 1 : -1) : -1);
        this.sortDirection = 'desc';
      } else {
        this.items.data.sort((a, b) => (a[sortKey] > b[sortKey]) ? -1 : (a[sortKey] === b[sortKey]) ? ((a[sortKey] > b[sortKey]) ? 1 : -1) : 1);
        this.sortDirection = 'asc';
      }
    },

    onDocumentErrored(error) {
      this.errorMessages = [error.text];
    },

    showNotifications() {
      const hidden = localStorage.getItem(Common.localStorageKeys.map.hideNotifications);
      return hidden === null && this.notifications;
    },

    closeNotifications() {
      this.notifications = null;
      localStorage.setItem(Common.localStorageKeys.map.hideNotifications, 'true');
    },

    updateMapZoom() {
      this.zoom = Map.getZoom();
    },

    loadPdfRegistrations(status) {
      this.loadRegistrations = status;
    },

    pdfMouseover(registryId) {
      const filtered = this.items.data.filter((registry) => registry.id === registryId)
      if (filtered.length === 0) {
        return;
      }
      this.pdfActive = {
        lat: filtered[0].latitude ?? filtered[0].lat,
        lng: filtered[0].longitude ?? filtered[0].lng
      };
    },

    pdfClick(registryId) {
      const filtered = this.items.data.filter((registry) => registry.id === registryId)
      if (filtered.length === 0) {
        return;
      }
      this.pdfActive   = {
        lat: filtered[0].latitude ?? filtered[0].lat,
        lng: filtered[0].longitude ?? filtered[0].lng
      };
      this.centerPoint = {
        lat: filtered[0].latitude ?? filtered[0].lat,
        lng: filtered[0].longitude ?? filtered[0].lng
      };
    },

    pdfMouseout() {
      this.pdfActive = null;
    },

    clickTemporaryHideImages() {
      this.temporaryHideImages = !this.temporaryHideImages;
    },

    toggleMyMarkers() {
      this.myMarkers = !this.myMarkers;
      if (this.myMarkers === false) {
        this.rightSidebar = false;
      }
    },

    /**
     * Move to current position
     */
    moveToCurrentPosition(position) {
      this.currentLocation = GPS.getPosition(position);
    },

    /**
     * Display geolocation error
     */
    displayGeolocationError(error) {
      this.errorMessages = [GPS.getError(error)];
    },

    /**
     * Geo location
     */
    geolocation() {
      GPS.geolocation(this.moveToCurrentPosition, this.displayGeolocationError);
    },

    /**
     * 操作ガイドを開く
     */
    clickOpenGuide() {
      window.open('https://cdn.jon-api.com/shikaku-map/guide.pdf', '操作ガイド');
    },
    /**
     * 種別コードを種別名へ変換
     *
     * @param pdfType
     * @returns {string}
     */
    getPdfTypeName(pdfType) {
      let pdfName = '';
      this.pdfTypes.forEach(pdfTypeItem => {
        if (pdfType === pdfTypeItem.code) {
          pdfName = pdfTypeItem.name;
        }
      });
      return pdfName;
    },
    /**
     * 自身が取得した内容か
     *
     * @param itemAccountId
     * @returns {string}
     */
    acquiredBySelf(itemAccountId) {
      return itemAccountId === this.accountId ? 'is-mine-item' : 'is-others-item';
    },
    /**
     * ジオコーディングで結果が見つからなかった時メッセージを表示
     */
    geocodingNotFound() {
      this.errorMessages = [Common.messages.map.geocodingNotFound];
      this.searching     = false;
    },
    /**
     * Have no search result
     */
    jonSearchNotFound(error = null) {
      this.errorMessages = [error ?? Common.messages.map.jonSearchNotFound];
      this.searching     = false;
    },
    /**
     * Do not fill the keyword
     */
    requiredAddress() {
      this.errorMessages = [Common.messages.map.requiredAddress];
      this.searching     = false;
    },
    /**
     * Begin searching
     */
    beginSearch() {
      this.searching = true;
    },
    /**
     * Finish searching
     * @param message
     */
    searched(message = null) {
      this.searching = false;
      if (message !== null) {
        this.errorMessages = [message];
      }
    },

    registrationDialogClosed() {
      this.showRegistrationDialog = false;
      this.parcelNumber           = null;
      this.registrationItem       = null;
      Map.getPdfRegistration(this.$refs['map_google']);
    },

    displayRegistryErrors({errorMessages}) {
      this.errorMessages = errorMessages;
    },

    displayPdfError({message}) {
      this.pdfErrorMessage = message;
    },

    reObtainRegistrationInformation(item) {
      this.landMarkerPoint              = null;
      this.showRegistrationDialog       = true;
      this.loadReObtainRegistrationInfo = true;
      this.rightSidebar                 = false;
      this.dataLayerSidebar             = false;
      this.loadPoint                    = true;
      Map.getDataPoint(this.$refs['map_google'], {
        lat: item.latitude ?? item.lat,
        lng: item.longitude ?? item.lng,
      });
      if (item.number_type === 1) {
        this.parcelConfirmed(item.number);
      } else {
        this.buildingConfirmed(item);
      }
    },
    /**
     * ローディングアイコンを表示するか
     * 対象：初期ロード、地番地図取得中、JON検索中
     * @returns {boolean}
     */
    showLoadingSpinner() {
      return (this.initLoading && !this.isTrialEnded) ||
          this.loadChibanRosen ||
          (this.searching && this.searchType === Common.locationSearchTypes.jon.code);
    },
    isKokudoYouto(layerType = '') {
      console.log(layerType);
      this.isLayerTypeKoudoYouto = layerType === 'kokudo_youto';
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components.scss";

.page-container {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}

.md-app {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border: 1px solid rgba(#000, .12);
}

.md-drawer {
  width: 230px;
  max-width: calc(100vw - 125px);

  .md-list {
    height: 100%;
    padding: 0;
  }
}

.md-app-content {
  padding: 0;
}

.md-dialog {
  transform: inherit;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  &-content-pdf {
    display: flex;

    object {
      width: 100%;
    }
  }

  &-registration {
    display: flex;
    width: 100%;

    ::v-deep(.md-dialog-container) {
      min-width: 100%;
      min-height: 100%;
    }
  }

  &-confirming {
    background: lightgray;
  }

  &--small {
    width: 600px;
    height: 220px;
  }
}

.rosen-modal {
  padding: 0 4px 6px 0;
}

.img-content {
  min-width: 500px !important;
}

.mt-10 {
  margin-top: -10px;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-30 {
  margin-bottom: 30px;
}

.mt-20 {
  margin-top: 20px;
}

.pt-0 {
  padding-top: 0 !important;
}

.pr-0 {
  padding-right: 0 !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pl-0 {
  padding-left: 0 !important;
}

.md-snackbar {
  &-bg {
    &__information {
      background-color: #fefefe;
      color: #333333;
      z-index: 20;

      .md-layout {
        display: contents;;
      }
    }

    &__error {
      background-color: #fefefe;
      z-index: 20;
    }

    &__success {
      background-color: #fefefe;
      color: #333333;
      z-index: 20;
    }

    &__white {
      z-index: 20;
    }
  }

  width: 100%;
  max-width: 640px;

  .md-button {
    width: 100px;
  }

  &-wide {
    max-width: 70%;
    max-height: none;
    padding: 7px 24px;
    margin: 0;

    .caption {
      font-size: 92%;
      line-height: 1.2em;
      margin: 0;
    }

    .x-caption {
      font-size: 76%;
      line-height: 1.2em;
      margin: 4px 0;
    }

    .moving-points {
      margin: 2px auto;
    }
  }

  &-button {
    min-width: 345px;
  }
}

.ie-browser {
  .md-layout {
    flex-wrap: nowrap;
  }

  .md-layout-item {
    flex-basis: auto;
  }

  .md-table {
    flex-direction: inherit;
  }
}

.pdf-preview {
  height: 100%;

  object {
    width: 100%;
    height: 100%;
  }
}

.contact {
  color: rgba(0, 0, 0, 0.87);
}

.md-field-height-auto {
  min-height: 0;
}

td .md-progress-spinner {
  margin: 0;
}

.md-title:not(:first-child) {
  margin-top: 10px;
}

.md-form {
  background: transparent;
  display: flex;
  flex: 2;

  .md-icon:after {
    background: transparent;
  }

  & > .md-layout {
    flex: 1;
  }
}

/*取得モーダル.地番／家屋番号一覧*/
.parcel-number,
.house-number {
  max-height: 104px;
  overflow-y: scroll;

  .md-table-row {
    .md-table-head {
      border: solid 1px rgba(0, 0, 0, 0.2);
    }

    ::v-deep(.md-table-head-container) {
      height: 26px;
      padding: 0;

      .md-table-head-label {
        padding-right: 0;
        padding-left: 0;
      }
    }

    ::v-deep(.md-table-cell-container) {
      padding: 0 6px;
      font-size: 14px;
    }

    .md-table-cell {
      border: solid 1px rgba(0, 0, 0, 0.2);
      padding: 0 !important;

      .md-field, .md-checkbox {
        margin: 0 !important;
      }

      .md-field {
        min-height: 36px;
        padding-top: 0;
      }
    }

    .md-table-head:nth-child(1),
    .md-table-cell:nth-child(1) {
      width: 65px;
      text-align: center;
    }

    .md-table-head:nth-child(3),
    .md-table-head:nth-child(4),
    .md-table-head:nth-child(5),
    .md-table-head:nth-child(6),
    .md-table-cell:nth-child(3),
    .md-table-cell:nth-child(4),
    .md-table-cell:nth-child(5),
    .md-table-cell:nth-child(6) {
      width: 85px;
      text-align: center;
    }
  }
}

.house-number {
  max-height: 196px;
  overflow: auto;
}

/*取得済みリスト*/
.md-registrations {
  max-height: calc(100vh - 210px);
  overflow-y: auto;
  -webkit-transform: translate3d(0, 0, 0);

  .md-table-head {
    border: solid 1px rgba(0, 0, 0, 0.2);

    ::v-deep(.md-table-head-container) {
      height: 26px;
      padding: 0
    }
  }

  .md-table-cell {
    border: solid 1px rgba(0, 0, 0, 0.2);
    padding: 0 !important;
    cursor: pointer;

    ::v-deep(.md-table-cell-container) {
      padding: 6px 8px;
    }
  }

  .md-button {
    min-width: 26px;
    max-width: 26px;
    height: 26px;
  }

  .md-alignment-center {
    background: transparent !important;
  }

  .md-button.md-small {
    height: 25px;
    max-width: 100%;
  }

  .md-icon {
    width: 18px;
    min-width: 18px;
    height: 18px;
    font-size: 18px !important;
  }

  .md-caption {
    margin-top: 5px;
    margin-left: 2px;
    display: inline-table;
  }

  .md-address {
    margin-top: 4px;
    margin-left: 8px;
    display: block;
  }

  .is-mine-item {
    opacity: 1.0;
  }

  .is-others-item {
    opacity: 0.5;
  }
}

.md-left-sidebar {
  max-width: 220px;
  height: calc(100vh - 66px);
  overflow-y: auto;
}

.md-right-sidebar {
  max-width: 300px;
  display: flex;
  flex-direction: column;

  &__header {
    height: 96px;
    max-height: 96px;

    .md-layout-item {
      margin-left: 10px;
      margin-right: 10px;
    }

    .md-registrations {
      width: 100%;

      &_3column {
        .md-table-head:nth-child(1) {
          width: 25%
        }
      }
    }
  }

  &__content {
    flex-grow: 2;
    max-height: calc(100vh - 210px);
  }

  &__footer {
    display: flex;
    flex-direction: column;
  }

  .md-toolbar {
    padding: 0;
  }

  .moving-point-checkbox {
    margin: 1px 0 0 10px !important;
  }
}

// iPadでマイマーカの位置を変更するボタンが隠れてしまう対応
_::-webkit-full-page-media, _:future, :root .md-right-sidebar__content {
  max-height: calc(100vh - 218px);
}

.md-right-sidebar__content-message {
  height: 100%;
  text-align: center;
}

.text-error {
  color: #ff5252;
}

.md-expand-items {
  margin-bottom: 8px;

  ::v-deep(.md-list-item.md-inset) {
    .md-list-item-content {
      min-height: 24px;
      font-size: 0.7rem;
    }
  }
}

.md-loading {
  text-align: center;
  margin-top: 40vh;
}

.messages-on-trial {
  position: fixed;
  top: 85px;
  right: 60px;
  text-align: right;
  width: 28em;
  color: #ff5252;
  font-weight: bold;
  text-shadow: 1px 1px 8px #fff;
}

@media screen and (max-width: 812px) {
  .messages-on-trial {
    top: 118px;
  }
}

// 右クリック時にオリジナルコンテキストメニューとブラウザのコンテキストメニューがかぶらないように
::v-deep(.ctx-menu-container) {
  margin-left: 0.8em;
  margin-top: 0.8em;
}

.md-dialog-close-button {
  position: absolute;
  top: 0;
  right: 0;
  margin: 24px;
  cursor: pointer;
}

.md-search-button {
  min-width: 4rem;
}

.md-toolbar-row {
  .md-toolbar-section-start {
    flex-grow: 0.8;
  }

  .md-toolbar-section-end {
    flex-grow: 0.5;
  }

  .md-content {
    flex-grow: 2;

    .md-layout {
      margin: 0 auto;

      .md-layout-item:nth-child(1) {
        max-width: 140px;
      }

      .md-layout-item:nth-child(2) {
        margin-right: 8px;

        input {
          padding-right: 2px;
        }
      }

      .md-layout-item:nth-child(3) {
        max-width: 210px;
      }
    }
  }
}
</style>

<style lang="scss">
.search-type {
  .md-select {
    input {
      text-align: center;
    }
  }
}

.measure-result {
  padding: 0.5em 0;
}

.md-select-menu {
  z-index: 20 !important;
}

.marker-position {
  left: calc(50%);
  position: relative;
  color: indianred !important;
  font-size: 16px;
  font-weight: 700;
  margin-left: 18px;
}
</style>
<script setup>
</script>
